// extracted by extract-css-chunks-webpack-plugin
module.exports = {"news_box":"news_box-1LyBXkg0 clearfix","box_r":"box_r-3XQwcs1F","d_box":"d_box-2RCQ-uC-"};